import { useTranslation } from "react-i18next";

export default function Guides() {
  const { t } = useTranslation();
  const guides = t("home.guides.items", { returnObjects: true }) as Array<{
    title: string;
    desc: string;
  }>;

  const icons = [
    "ri-star-line",
    "ri-truck-line",
    "ri-shield-check-line",
    "ri-archive-line",
    "ri-coupon-line",
    "ri-camera-line",
  ];

  return (
    <section id="guides" className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3">
            {t("home.guides.title")}
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {guides.map((guide, i) => (
            <div
              key={guide.title}
              className="group p-6 rounded-xl bg-gray-50 hover:bg-emerald-50 transition-colors border border-gray-100 hover:border-emerald-200"
            >
              <div className="w-12 h-12 rounded-lg bg-emerald-100 flex items-center justify-center mb-4 group-hover:bg-emerald-200 transition-colors">
                <i className={`${icons[i]} text-emerald-700 text-xl`} />
              </div>
              <h3 className="font-semibold text-gray-900 mb-2">{guide.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{guide.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}